import { FormGroup, Typography } from '@mui/material';
import React, { useState } from 'react';
import { FieldValues, UseFormWatch } from 'react-hook-form';

import { WsLocationSearch } from '../../WsLocationSearch';
import { WsTypoVariants, WsTypoColors } from '../../WsTypography/WsTypography';
import EditCommonComponent from '../EditCommonComponent';

export interface LocationSearchEditProps {
  name: string;
  multiSelect?: boolean;
  defaultValue?: string | null;
  textVariant?: WsTypoVariants;
  color?: WsTypoColors;
  watch: UseFormWatch<FieldValues>;
  onConfirm: (key: string, value: any) => void;
}
const LocationSearchEdit = ({
  name,
  textVariant,
  defaultValue = 'Search For Location',
  color,
  multiSelect,
  watch,
  onConfirm,
}: LocationSearchEditProps) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [tempValue, setTempValue] = useState<any | null>();
  const locationSearch = watch(name);
  const handleConfirm = () => {
    onConfirm(name, watch(name));
    setIsEdit(false);
    setTempValue(locationSearch);
  };
  const handleClose = () => setIsEdit(false);

  return (
    <>
      {isEdit ? (
        <FormGroup>
          <WsLocationSearch
            name={name}
            placeHolder="Search For Location"
            multiSelect={multiSelect}
          />
          <EditCommonComponent onClose={handleClose} onConfirm={handleConfirm} />
        </FormGroup>
      ) : (
        <Typography
          variant={textVariant}
          color={color}
          sx={{
            overflow: 'hidden',
            display: 'block',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
          onClick={() => {
            setIsEdit(!isEdit);
          }}
        >
          {tempValue ? (
            <>
              {tempValue.city && <span>{tempValue.city}, </span>}
              {tempValue.state && <span>{tempValue.state}, </span>}
              {tempValue.country && <span>{tempValue.country}</span>}
            </>
          ) : (
            <>{defaultValue}</>
          )}
        </Typography>
      )}
    </>
  );
};
export default LocationSearchEdit;
